import React, { createRef, useContext, useEffect, useRef, useState } from 'react';
import styles from '../styles/main.module.scss';

import GlobalContext from '../_contexts/GlobalContext';
import Header from './Header';
import Footer from './footerComponent';
import { Popup, Stack, Image, TextField, PrimaryButton, FontSizes, Label } from '@fluentui/react';
import { popupStyles } from '../constants/constants';
import { TextComp } from './parts/TextComp';

export interface IRequestFormProps {
    apiUrl : string;
    setmessage: Function;
    seterror: Function;
}

export type TValidationError = {
    Field: string;
    Error: string;
}

const RequestForm: React.FunctionComponent<IRequestFormProps> = (props: IRequestFormProps) => {
    const [site, setsite] = useState<string>("");
    const [category, setcategory] = useState<string>("");
    const [naam, setnaam] = useState<string>("");
    const [email, setemail] = useState<string>("");
    const [telefoon, settelefoon] = useState<string>("");
    const [postalcode, setpostalcode] = useState<string>("");
    const [huisnummer, sethuisnummer] = useState<string>("");
    const [straat, setstraat] = useState<string>("");
    const [stad, setstad] = useState<string>("");
    const [bedrijf, setbedrijf] = useState<string>("");
    const [kvk, setkvk] = useState<string>("");
    const [errors, seterrors] = useState<TValidationError[]>([]);
    const [doVal, setdoVal] = useState<number>();
    const [validated, set_validated] = useState<boolean>(false);

    const { TakenSites } = useContext(GlobalContext);

    useEffect(() => {
        if (postalcode && huisnummer) {
            fetch(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:${postalcode}&fq=huisnummer=${huisnummer}`)
                .then(response => response.json())
                .then(data => {
                    if (data.response.numFound >= 1) {
                        setstraat(data.response.docs[0].straatnaam);
                        setstad(data.response.docs[0].woonplaatsnaam);
                    }
                })
                .catch(error => console.log(error));
        }
    }, [postalcode, huisnummer]);

    useEffect(() => {
        let validated = false;
        
        if (site?.length &&
            category?.length &&
            naam?.length &&
            email?.length &&
            postalcode?.length &&
            huisnummer?.length &&
            straat?.length &&
            stad?.length
            ) {
            validated = true;
        }
        
        set_validated(validated);
        
    },[site,naam,email,telefoon,postalcode,huisnummer,straat,stad]);

    function ReValidate(field: string) {
        if (errors.filter(err=> err.Field === field).length > 0) setdoVal(Date.now);
    }

    function submit() {
        let formData = new FormData();
        formData.append("sitename", site);
        formData.append("category", category);
        formData.append("name", naam);
        formData.append("email", email);
        formData.append("postalcode", postalcode);
        formData.append("homenumber", huisnummer);
        formData.append("street", straat);
        formData.append("city", stad);
        formData.append("telefoon", telefoon ? telefoon : "");
        formData.append("company", bedrijf ? bedrijf : "");
        formData.append("kvk", kvk ? kvk : "");
        

        fetch(`${props.apiUrl}/Request`, {
                method: "Put", 
                mode: "cors", 
                referrerPolicy: "origin-when-cross-origin",
                body: formData
            }).then((response) => response.json()).then((data) => {
                if (data.success) {
                    props.setmessage("Inschrijving toegevoegd. We nemen z.s.m. contact met u op");
                } else {
                    props.seterror(data.error);
                }
            }).catch((ex) => {
                console.log(ex);
            });
    }

    return (
        <Stack style={{padding:10,minWidth:370}}>
            <div style={{backgroundColor:'lightblue', borderRadius:5, padding: 5}}>
                <h2>Inschrijven</h2>
            </div>
            <TextField required label='Site naam' maxLength={50} suffix='.collectietekoop.nl' value={site} onChange={(e,v) => { setsite(v); ReValidate("site"); }} onBlur={()=>{ setdoVal(Date.now); }} />
            {errors.map(error => {
                if (error.Field === "site") {
                    return <Label style={{color:"red",fontSize:"small"}}>{error.Error}</Label>
                }
            })}

            <TextComp required label='Artikelen categorie' validate={/^[a-zA-Z0-9]/g} onChange={setcategory} />
            <TextComp required label='Naam' validate={/^[a-zA-Z0-9]/g} onChange={setnaam} />
            <TextComp required label='E-mail' validate={/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/} onChange={setemail} />
            
            <Stack horizontal style={{width:"100%"}}>
                <TextComp required validate={/^[0-9]{4}[a-zA-Z]{2}/g} label='Postcode' onChange={setpostalcode} style={{width:"50%"}}/>
                <TextComp required validate={/^[0-9]{1,5}[a-zA-Z]{0,5}/g} label='Huisnummer' onChange={sethuisnummer} style={{paddingLeft:10, width:"50%"}} />
            </Stack>
            <TextComp required validate={/^[a-zA-Z0-9]/g} label='Straat' onChange={setstraat} value={straat} />
            <TextComp required validate={/^[a-zA-Z0-9]/g} label='Woonplaats' onChange={setstad} value={stad} />
            <br/>
            <TextComp validate={/^[a-zA-Z0-9]/g} label='Telefoonnummer' onChange={settelefoon} />
            <TextComp validate={/^[a-zA-Z0-9]/g} label='Bedrijf naam' onChange={setbedrijf} />
            <TextComp validate={/^[a-zA-Z0-9]/g} label='KvK nummer' onChange={setkvk} />

            <Stack horizontalAlign='end'>
                <PrimaryButton disabled={!validated} text="Indienen" style={{margin:10}} onBlur={()=>{ setdoVal(Date.now); }} onClick={submit} />
            </Stack>
        </Stack>
    );
}

export default RequestForm;